module.exports = __webpack_public_path__ + "img/icon_parkingCoupon.a3e49835.png";